import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon } from '../fileStatusIconSize';

export type FileStatusIconPreparingProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconPreparing = memo(({ size = 'default' }: FileStatusIconPreparingProps) => {
  const { container, spinner } = fileStatusIcon({ size });

  return (
    <div
      aria-hidden
      className={cn('flex items-center justify-center rounded-full ads:bg-ads-gray-4 bg-gray-4', container())}
    >
      <Spinner className={spinner()} color="gray" />
    </div>
  );
});

FileStatusIconPreparing.displayName = 'FileStatusIconPreparing';
